import { httpClient } from './../httpClient';
import { apiErrorHandler } from './helpers';
import { useCustomQuery, useCustomPaginatedQuery } from 'hooks/reactQuery';

export const getRelatedRoomTypeByUnitId = id =>
  httpClient
    .get(`/unit/listing/roomType/${id}`)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const putUpdateUnit = (id, payload) =>
  httpClient
    .put(`/unit/${id}`, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const putUpdateUnitConfig = (id, payload) =>
  httpClient
    .put(`/unit/${id}/config`, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const putRentalUnit = (id, payload) =>
  httpClient
    .put(`/unit/rental/${id}`, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);

export const deleteRemoveUnit = id => httpClient.delete(`/unit/${id}`).then(response => response.data); // NOTE: This endpoint doesn't have .catch because it needs to have a custom error handler in the page.

export const getRelationships = id =>
  httpClient
    .get(`/unit/${id}/relationship`)
    .then(res => res.data)
    .catch(apiErrorHandler);

export const getPotentialParentList = id =>
  httpClient
    .get(`/unit/${id}/parentList`)
    .then(res => res.data)
    .catch(apiErrorHandler);

export const getPotentiaChildList = id =>
  httpClient
    .get(`/unit/${id}/childList`)
    .then(res => res.data)
    .catch(apiErrorHandler);

export const updateParentChild = (id, children) =>
  httpClient
    .patch(`/unit/${id}/setChildren`, children || [])
    .then(res => res.data)
    .catch(apiErrorHandler);

export const patchUpdateUnitRoomType = (unitId, roomTypeId) =>
  httpClient
    .patch(`/unit/${unitId}/roomType`, { roomTypeId })
    .then(res => res.data)
    .catch(apiErrorHandler);

// ======================= hooks =============================== //

export const useGetPaginatedUnitListings = query => {
  const getPaginatedUnitListings = async (key, query) => {
    return httpClient
      .get('/unit/paginated', { params: query })
      .then(res => res.data)
      .catch(apiErrorHandler);
  };

  return useCustomPaginatedQuery('units', getPaginatedUnitListings, query);
};

export const useGetPaginatedUnitRentals = query => {
  const getUserUnitRentals = async (key, query) => {
    return httpClient
      .get('/unit/rental', { params: query })
      .then(response => response.data)
      .catch(apiErrorHandler);
  };

  return useCustomPaginatedQuery('units', getUserUnitRentals, query);
};

export const useGetUnitListings = query => {
  const getUserUnitListings = () => {
    return httpClient
      .get('/unit/listing')
      .then(response => response.data)
      .catch(apiErrorHandler);
  };

  return useCustomQuery('getUserUnitListings', [], getUserUnitListings, { shouldDefaultEmptyObject: false });
};

export const useGetUnitDetails = (id, { isIncludeUnitRelation } = {}) => {
  const getUnitDetails = (key, id, isIncludeUnitRelation) =>
    httpClient
      .get(`/unit/listing/${id}`, { params: { isIncludeUnitRelation } })
      .then(response => response.data)
      .catch(apiErrorHandler);

  return useCustomQuery('getUnitDetails', [id, isIncludeUnitRelation], getUnitDetails, { shouldDefaultEmptyObject: false });
};

// ========================================ADMIN
// ----------------------------GET
export const useGetUnitsWithoutPrimary = (hostId, unitId, postProcessFunc) => {
  const getUnitsWithouPrimary = (key, hostId, unitId) =>
    httpClient
      .get(`/admin/unit/host/${hostId}`, { params: { unitId } })
      .then(response => response.data)
      .catch(apiErrorHandler);

  return useCustomQuery('getUnitsWithouPrimary', [hostId, unitId], getUnitsWithouPrimary, { shouldDefaultEmptyObject: false, postProcessFunc });
};

// ----------------------------UPDATE
export const putUpdateHostProtect = (id, payload) =>
  httpClient
    .put(`/admin/unit/${id}/protection`, payload)
    .then(response => response.data)
    .catch(apiErrorHandler);
